import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class SeoRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getTagcloudSeo() {
    throw new Error('[SeoRepository#getTagcloudSeo] must be implemented')
  }

  getRemoteSeoContent() {
    throw new Error('[SeoRepository#getRemoteSeoContent] must be implemented')
  }
}
